export default "__VITE_ASSET__4H4z_vHl__"